//Built-in libraries

//Third party libraries

//Custom components

//Services
import { accountingFormatNumber, formatDate3, formatNumber, formatPhoneNumber } from '@/utils';

//STP Libraries

//Assets and Miscellaneous

//Component Begin

export interface IProjectDetailsProps {
  step1: any;
}
export default function ProjectDetails({ step1 }: IProjectDetailsProps) {
  const { section1, section2, section3, section4 } = step1;
  return (
    <section aria-labelledby='applicant-information-title'>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
              Application Information
            </h2>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6'>
          <h3 className='py-4'>Project Information</h3>
          <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 mb-8'>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Bond Bill</dt>
              <dd className='mt-1 text-sm text-gray-900'>{section1.bondBill}</dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Project Title</dt>
              <dd className='mt-1 text-sm text-gray-900'>{section1.projectTitle}</dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Legislative District</dt>
              <dd className='mt-1 text-sm text-gray-900'>{section1.legislativeDistrict}</dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>DGS Item Number</dt>
              <dd className='mt-1 text-sm text-gray-900'>{section1.dgsItemNumber}</dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Address</dt>
              <dd className='mt-1 text-sm text-gray-900'>
                {section1.streetAddress}, {section1.city}, {section1.state}, {section1.zipCode}
              </dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Authorized Year</dt>
              <dd className='mt-1 text-sm text-gray-900'>{section1.authorizedYear}</dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Chapter Number</dt>
              <dd className='mt-1 text-sm text-gray-900'>{formatNumber(section1.chapterNumber)}</dd>
            </div>
          </dl>
          <h3 className='py-4'>Grantee Information</h3>
          <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 mb-8'>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Grantee Organization</dt>
              <dd className='mt-1 text-sm text-gray-900'>{section2.granteeOrganization}</dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Grantee Amount</dt>
              <dd className='mt-1 text-sm text-gray-900'>
                {accountingFormatNumber({
                  num: section2.grantAmount,
                  format: 'en-US',
                  currency: 'USD',
                })}
              </dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Match Amount</dt>
              <dd className='mt-1 text-sm text-gray-900'>
                {accountingFormatNumber({
                  num: section2.matchAmount,
                  format: 'en-US',
                  currency: 'USD',
                })}
              </dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Address</dt>
              <dd className='mt-1 text-sm text-gray-900'>
                {section2.streetAddress}, {section2.city}, {section2.state}, {section2.zipCode}
              </dd>
            </div>
          </dl>
          <h3 className='py-4'>Grantee Interest in real property to be improved with Grant</h3>
          <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 mb-8'>
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>Grantee organization is the sole owner</dt>
              <dd className='mt-1 text-sm text-gray-900'>{section3.isSoloOwner ? 'Yes' : 'No'}</dd>
            </div>
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>Grantee organization is a co-owner</dt>
              <dd className='mt-1 text-sm text-gray-900'>{section3.isCoOwner ? 'Yes' : 'No'}</dd>
            </div>
            {section3.isCoOwner && (
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Co-owner Name</dt>
                <dd className='mt-1 text-sm text-gray-900'>{section3.coOwnerName}</dd>
              </div>
            )}
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>
                Grantee does not own the property, but has a long-term lease. Indicate term and provide a copy of the lease
              </dt>
              <dd className='mt-1 text-sm text-gray-900'>{section3.hasLongTermLease ? 'Yes' : 'No'}</dd>
            </div>
            {section3.hasLongTermLease && (
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Lease Term</dt>
                <dd className='mt-1 text-sm text-gray-900'>{section3.leaseTerm}</dd>
              </div>
            )}
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>Grantee does not own or lease the project property</dt>
              <dd className='mt-1 text-sm text-gray-900'>{section3.doesNotOwn ? 'Yes' : 'No'}</dd>
            </div>
            {section3.doesNotOwn && (
              <>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Owner Name</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{section3.ownerName}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Owner Email</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{section3.ownerEmail}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Owner Phone Number</dt>
                  <dd className='mt-1 text-sm text-gray-900'>+1 {formatPhoneNumber(section3.ownerPhoneNumber)}</dd>
                </div>
              </>
            )}
          </dl>
          <h3 className='py-4'>Estimated Project Schedule</h3>
          <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 mb-8'>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Design</dt>
              <dd className='col-span-3 space-x-4'>
                <span>Start Date: {formatDate3(section4?.design.startDate)}</span>
                <span>Finish Date: {formatDate3(section4?.design.finishDate)}</span>
              </dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Construction</dt>
              <dd className='col-span-3 space-x-4'>
                <span>Start Date: {formatDate3(section4?.construction.startDate)}</span>
                <span>Finish Date: {formatDate3(section4?.construction.finishDate)}</span>
              </dd>
            </div>
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>Project Description and Scope</dt>
              <dd className='mt-1 text-sm text-gray-900'>{section4?.description}</dd>
            </div>
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>
                Does this project require a preservation easement to the Maryland Historical trust?
              </dt>
              <dd className='mt-1 text-sm text-gray-900 capitalize'>{section4?.requirePreservationEasement}</dd>
            </div>
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>
                You are encouraged to solicit MBE enterprises. Will this project utilize MBE enterprises to provide construction,goods
                and/or Services ?
              </dt>
              <dd className='mt-1 text-sm text-gray-900 capitalize'>{section4?.utilizeMBEEnterprise}</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}
